export function isMobile(value) {
  value = value.replace(/[^-|\d]/g, '');
  return /^((\+86)|(86))?(1)\d{10}$/.test(value) || /^0[0-9-]{10,13}$/.test(value);
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/validate/mobile.js
// module id = 153
// module chunks = 73